import React, {Component} from 'react'
// import { connect } from 'react-redux'

import Popup from '../Popup/index';

import Registry from '../../../registry/index';

class BecomeXXLPopup extends Popup {
    constructor(props) {
        super(props);

        this.showOverlay = true;
        this.userClosable = true;
        this.afterClosePositionReset = false;
    }

    render() {
        let lang = Registry.get('locale');

        let {id} = this.props;

        let className = 'popup popup-become-xxl ' + id + ' ' + this.state.visibility;

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                <p>
                    <span className="prefix" dangerouslySetInnerHTML={{__html:lang.become_xxl_to}}></span>
                    <span className="feature" dangerouslySetInnerHTML={{__html:lang.xxl_feature}}></span>
                    <span className="fullscreen">{lang.xxl_fullscreen}</span>
                    <span className="pm">{lang.xxl_pm}</span>
                    <span className="exclude">{lang.xxl_exclude}</span>
                    <span className="block">{lang.xxl_block}</span>
                    <span className="follow">{lang.xxl_follow}</span>
                    <span className="create-room">{lang.xxl_create_room}</span>
                    <span className="attach-photo">{lang.xxl_attach_photo}</span>.
                </p>
                <div className="buttons">
                    <a href="#" className="popup-button close" onClick={() => this.close()}>{lang.close}</a>
                </div>
             </div>
        )   
    } 

}

BecomeXXLPopup.generateKey = function(props) { return 'become-xxl-popup' };
BecomeXXLPopup.mount = function(props) { Popup.mount(BecomeXXLPopup, props) };
BecomeXXLPopup.open = function(id) {
    BecomeXXLPopup.mount({id : id, ref : (r) =>
        Popup.popups[BecomeXXLPopup.generateKey()].open()
    });
    
};

export default BecomeXXLPopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/BecomeXXLPopup/index.js